<template>
  <div class="container-box">
    <el-table :data="info.insuranceInfo" border size="mini" max-height="400px">
      <el-table-column prop="insuranceNo" label="编号" align="center" />
      <el-table-column prop="applicantName" label="投保人姓名" align="center" />
      <el-table-column prop="applicantIdCard" label="投保人身份证" align="center" />
      <el-table-column prop="insurancePrice" label="保费" align="center" />
      <el-table-column prop="insuranceOrderNo" label="保单号" align="center" />
      <el-table-column prop="insuranceProgramCode" label="保险方案代码" align="center" />
      <el-table-column prop="status" label="状态" align="center" />
      <el-table-column prop="errorMsg" label="错误信息" align="center" />
      <el-table-column prop="applicantTime" label="投保时间" align="center" />
      <el-table-column prop="insureEffectTime" label="投保生效时间" align="center" />
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'insuranceOrderInfo',
    props: {
      info: {}
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  .container-box {
    margin: 12px 0 30px 0;
    padding: 0 10px;
  }
</style>
